<template>
  <div class="main_view">
    <!--导航栏-->
    <div class="report_head">
      <div class="report_head_item">
        <div class="report_head_left">
          <div class="report_info">
            <a href="/#/" target="_blank">
              <img src="/static/images/bigdata/maoyan_logo.png"/>
            </a>
          </div>
          <div class="line"></div>
          <div class="note">
            <span>小红书AI智能投放分析：<span style="color: #396AF2; font-weight: bolder">【{{keyWord}}】</span></span>
          </div>
        </div>
        <div class="report_head_right">
          <div class="item_right"  @mouseover="logoutOver" @mouseout="logoutOut">
            <img class="img_head" src="/static/images/bigdata/brand_head_icon.png"/>
            <div class="nick_name">{{nickName}}</div>
            <div class="logout" v-show="showLogin" @click="clickLogout">退 出 登 录</div>
          </div>
        </div>
      </div>
    </div>
    <!--切换栏-->
    <div class="report_home">
      <div class="shop">
        <div class="report_list">
          <div class="report_item_head">
            <div class="report_item_value" v-for="(headItem, headItemIndex) in headItems"
                 :key="headItemIndex" :class="{'selected' : headIndex === headItemIndex }" @click="clickHeadItem(headItemIndex)">{{headItem}}</div>
          </div>
        </div>
      </div>
    </div>
    <!--笔记列表-->
    <div class="master_list" v-if="kolList.length > 0">
      <el-radio-group class="item_radio" v-model="radio" @change="clickRadio" fill="#396AF2">
        <el-radio-button label="按点赞排序↓"></el-radio-button>
        <el-radio-button label="按评论排序↓"></el-radio-button>
        <el-radio-button label="按收藏排序↓"></el-radio-button>
        <el-radio-button label="按时间排序↓"></el-radio-button>
      </el-radio-group>
      <div class="item_list">
        <div class="item_line">
          <div class="item1 first" style="padding-left: 20px">笔记信息</div>
          <div class="item1 end">
            <div class="item_child">发布时间</div>
          </div>
          <div class="item1 end">
            <div class="item_child">点赞数</div>
          </div>
          <div class="item1 end">
            <div class="item_child">评论数</div>
          </div>
          <div class="item1 end">
            <div class="item_child">收藏数</div>
          </div>
        </div>
        <div class="item_line big" v-for="(kolItem, kolIndex) in kolList" :key="kolIndex"  @click="clickKolItem(kolItem.url)">
          <div class="item1 first" style="padding-left: 20px">
            <div class="user_info">
              <div class="user_img_bg">
                <div class="user_img">
                  <img :src="kolItem.image"/>
                  <i class="user_img_video" v-show="kolItem.type=='video'" style="background-image:url('/static/images/bigdata/xhs_note_video.png')"></i>
                </div>
              </div>
              <div class="user_data">
                <div class="data_name">{{kolItem.title}}</div>
                <div  class="note">{{kolItem.user_nickname}}</div>
                <div  class="note">{{kolItem.user_gender}} 粉丝：{{kolItem.user_fans}}</div>
              </div>
            </div>
          </div>
          <div class="item1 end">
            <div class="item_child">{{kolItem.pubtime}}</div>
          </div>
          <div class="item1 end">
            <div class="item_child">{{kolItem.liked_count}}</div>
          </div>
          <div class="item1 end">
            <div class="item_child">{{kolItem.comments_count}}</div>
          </div>
          <div class="item1 end">
            <div class="item_child">{{kolItem.collected_count}}</div>
          </div>
        </div>

        <div class="block-pagination" v-if="total > 0">
          <Pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="kolListObj.page_size"
            :current-page="kolListObj.page_index"
            layout="prev, pager, next"
            :total="total">
          </Pagination>
        </div>
      </div>
    </div>
    <!--底部导航-->
<!--    <div  class="bottom_div" v-if="kolList.length > 0">COPYRIGHT  2020-2023 杭州袤周云计算有限公司<a rel="nofollow" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2022031665号</a></div>-->
  </div>
</template>

<script>
import { Pagination } from 'element-ui'
import process from "shelljs";
export default {
  name: "BigdataNoteList",
  data() {
    return {
      radio: '按点赞排序↓',
      showLogin: false,
      nickName: this.$cookies.get('UserName') || '演示账号',
      keyWord: this.$cookies.get('KeyWord'),
      headIndex: 3,
      headItems: ['达人分析', '笔记分析', '达人列表', '笔记列表', '爆文分析'],
      total: 20,
      kolListObj: {
        page_index: 1,
        keyword: '',
      },
      kolList: []
    }
  },
  methods: {
    clickRadio() {
      this.getListData()
    },
    clickKolItem (url) {
      window.open(url, '_blank')
    },
    clickHeadItem (headIndex) {
      // 跳转
      if (headIndex === 0) {
        this.$router.push('/bigdata')
      }
      if (headIndex === 1) {
        this.$router.push('/note')
      }
      if (headIndex === 2) {
        this.$router.push('/kollist')
      }
      if (headIndex === 4) {
        this.$router.push('/notehot')
      }
    },
    clickLogout () {
      // 本地保存token
      this.$cookies.remove("UserToken")
      this.$cookies.remove("UserName")
      // 跳转
      this.$router.push('/login')
    },
    logoutOver () {
      this.showLogin = true
    },
    logoutOut () {
      this.showLogin = false
    },
    handleSizeChange: function (val) {
    },
    handleCurrentChange: function (val) {
      this.kolListObj.page_index = val
      this.getListData()
    },
    getListData() {
      let base = '/api';
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com'
      }
      let url = '/api/v2/maocep/maocep_bigdata_xhs_notes_list'
      // 排序
      let order_by = '-pubtime'
      if (this.radio === '按点赞排序↓') {
        order_by = '-liked_count'
      } else if(this.radio === '按评论排序↓') {
        order_by = '-comments_count'
      } else if(this.radio === '按收藏排序↓') {
        order_by = '-collected_count'
      } else {
        order_by = '-pubtime'
      }
      this.kolListObj.keyword = this.$cookies.get('KeyWord')
      //数据请求 HTTP_AUTHORIZATION
      this.$axios.defaults.headers.common['Authorization'] = this.$cookies.get('UserToken')
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          'page_index': this.kolListObj.page_index,
          'page_size': 20,
          'order_by': order_by,
          'keyword': this.$cookies.get('KeyWord')
        })
      }).then((res) => {
        console.log("res ", res);
        let data = res.data
        if (data.error === 0) {
          this.total = data.total_count
          this.kolList = data.result
          console.dir(this.total)
        }
      }).catch((res) => {
        console.log("..fail: ", res)
      })
    }
  },
  components: {
    Pagination,
  },
  mounted () {
    console.dir(this.$cookies);
    if (this.$cookies.get('UserToken')) {
      this.getListData();
    } else {
      console.dir('退出登录')
      this.clickLogout ();
    }
  },
  metaInfo: {
    title: "袤-AI数据挖掘系统",
    meta: [
      { name: "viewport", content: "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0" },
      { name: "keywords", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "description", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "format-detection", content: "telephone=no,email=no" }
    ],
    link: [{
      rel: 'shortcut icon',
      href: '/static/favicon.ico'
    }]
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '../comm/css/base.styl'
.main_view
  height 100vh
  -webkit-overflow-scrolling touch
  background-color $brand-bgm
  display flex
  flex-direction column
  width 100%
  overflow-y scroll
  overflow-x hidden
  .report_head
    position absolute
    left 0
    top 0
    width 100%
    z-index 1
    background-color $white
    height 75px
    box-shadow 0 1px 8px 0 rgba(0,0,0,0.1)
    .report_head_item
      width 1000px
      height 75px
      display flex
      margin 0 auto
      flex-direction row
      align-items center
      justify-content space-between
      .report_head_right
        width auto
        display flex
        position relative
        height 75px
        flex-direction row
        align-items center
        .item_right
          width auto
          display flex
          position relative
          height 75px
          flex-direction row
          align-items center
          .img_head
            height 32px
            border-radius 50px
            width 32px
          .logout
            position absolute
            width 120px
            height 38px
            display flex;
            flex-direction column
            align-items center
            justify-content center
            color $white
            cursor pointer
            z-index 1
            right 0
            top 60px
            font-size 14px
            background $grey
          .nick_name
            color $color-two
            font-size 14px
            margin-left 10px
      .report_head_left
        width auto
        display flex
        flex-direction row
        align-items center
        height auto
        .note
          margin-left 15px
          color $color-two
          font-size 20px
          font-weight bold;
          width auto
          display flex
          position relative
          height 75px
          flex-direction row
          align-items center
        .line
          margin-left 10px
          width 1px
          height 57px
          background-color $colorE
        .report_info
          height auto
          display flex
          flex-direction column
          img
            height auto


  .report_home
    display flex
    flex-direction row
    justify-content center
    margin 0 auto
    margin-top 90px
    width 1000px
    .shop
      display flex
      flex-direction row
      width 100%
      .report_list
        display flex
        width 100%
        flex-direction column
        .report_item_head
          display flex
          margin-top 15px
          margin-bottom 15px
          width 100%
          align-items center
          justify-content center
          flex-direction row
          .report_item_value
            height 30px
            width auto
            line-height 30px
            margin-right 40px
            font-size 12px
            cursor pointer
            color $color-six
            &.selected
              border-bottom solid 3px $brand-blue
              font-weight bold
              color $brand-blue
              font-size 14px

  .master_list
    border-radius 12px
    width 1000px
    margin 0 auto
    height auto
    margin-bottom 20px
    display flex
    flex-direction column
    background-color #FFFFFF
    .item_radio
      margin-left 20px
      margin-top 20px
      margin-bottom 10px
    .item_list
      width 100%
      margin-bottom 10px
      height auto
      background-color $white
      display flex
      border-radius 12px
      flex-direction column
      .item_line
        margin-left 20px
        width calc(100% - 40px)
        display flex
        flex-direction row
        align-items center
        height 35px
        background-color $brand-gray-bg
        &.big
          height 110px
          border-bottom 1px solid $shop-grey
          background-color $white
        .item1
          display flex
          flex-direction row
          color $koc-six
          cursor pointer
          font-size 12px
          height auto
          width 20%
          .user_info
            height 80px
            display flex
            color: $brand-gray
            font-size 11px
            align-items center
            flex-direction row
            .user_data
              margin-left 12px
              flex-direction column
              display flex
              .note
                margin-top 5px
              .data_name
                line-height 14px
                height 28px
                overflow hidden
                font-size 12px
                font-weight bold
                color $color-two
            .user_img_bg
              height 80px
              width 60px
              display flex
              flex-direction row
              align-items center
              justify-content center
              .user_img
                position relative
                img
                  height auto
                  width 60px
                  max-height 80px
                .user_img_video
                  width 20px
                  height 20px
                  background-size contain
                  background-repeat no-repeat
                  position absolute
                  top 1px
                  left 1px

          .item_child
            display flex
            flex-direction row
            align-items center
            justify-content center
            width 80px
          &.end
            justify-content flex-end
          &.first
            width 300px
    .block-pagination
      display flex
      width 100%
      padding-top 10px
      justify-content center
      align-items center


  .bottom_div
    background linear-gradient(135deg,rgba(51,51,51,1) 0%,rgba(17,17,17,1) 100%)
    width 100%
    height auto
    padding-top 20px
    padding-bottom 20px
    display flex
    color $white
    justify-content center
    flex-direction row
    align-items center
    a
      margin-left 10px
      margin-top 20px
      margin-bottom 20px
      color $white
</style>



// WEBPACK FOOTER //
// src/components/bigdata/BigdataNoteList.vue